import AttachApostleSVG from '@public/icons/icon-sanctuary-attach-apostle.svg'
import ChronomergeSVG from '@public/icons/icon-sanctuary-chronomerge.svg'
import ConjunctSVG from '@public/icons/icon-sanctuary-conjunction.svg'
import ForgeApostleSVG from '@public/icons/icon-sanctuary-forge-apostle.svg'
import SpiritualMergeSVG from '@public/icons/icon-sanctuary-spiritual-merge.svg'
import SharedSecNavBar from '@src/components/navigationBar/secondary/SharedSecNavBar'
import { NAV_BAR_CONFIG } from '@src/constants/layout'
import { ROUTE } from '@src/constants/route'
import { FC } from 'react'

const NAVIGATION_ITEMS = [
  {
    icon: ConjunctSVG,
    route: ROUTE.SANCTUARY_CELESTIAL_CONJUNCTION,
    translationKey: 'sub_bar.sanctuary.conjunction'
  },
  {
    icon: AttachApostleSVG,
    route: ROUTE.SANCTUARY_CELESTIAL_BINDING,
    translationKey: 'sub_bar.sanctuary.binding_apostle'
  },
  {
    icon: ForgeApostleSVG,
    route: ROUTE.SANCTUARY_APOSTLE_FORGE,
    translationKey: 'sub_bar.sanctuary.forge_apostle'
  },
  {
    icon: SpiritualMergeSVG,
    route: ROUTE.SANCTUARY_APOSTLE_FUSION,
    translationKey: 'sub_bar.sanctuary.apostle_spritiual_merge'
  },
  {
    icon: ChronomergeSVG,
    route: ROUTE.SANCTUARY_CHRONOMERGE,
    translationKey: 'sub_bar.sanctuary.merging'
  }
]

const SanctuarySecNavBar: FC<Props> = (props: Props) => {
  const { index = 0 } = props

  return (
    <SharedSecNavBar
      height={NAV_BAR_CONFIG.secondary.height}
      index={index}
      navigationItems={NAVIGATION_ITEMS}
    />
  )
}

type Props = {
  index: number
}

export default SanctuarySecNavBar
